import ImportField from './ImportField'

export default class BooleanField extends ImportField {

  public serialize() {
    return super.serializeWithType('boolean')
  }

}